import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	level: number
}

export const Wrapper = styled.li<Props>`
	font-family: ${helpers.font.family.base};
	margin: 0;
	padding-left: ${({ level }) => (level - 2) * 12}px;
	color: ${helpers.color.text};
`
